import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges, Type, ViewChild } from '@angular/core';
import { AnagraficaService } from '../../../services/anagrafica.service';
import { ButtonForm, FormsTemplateService, ISearchExpr, SearchOptions } from '../../../services/forms-template.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { alert } from 'devextreme/ui/dialog';
import { ComponentService } from '../../../services/component.service';
import { NicaDataGridComponent } from '../../nica-data-grid/nica-data-grid.component';



@Component({
  selector: 'app-editor-element',
  templateUrl: './editor-element.component.html',
  styleUrls: ['./editor-element.component.css']
})
export class EditorElementComponent implements OnInit, AfterViewInit {

  @ViewChild('input', { static: false }) input: ElementRef<HTMLInputElement>;
  @ViewChild('textArea', { static: false }) textArea: ElementRef<HTMLTextAreaElement>;
  @ViewChild('autocomplete', { static: false }) autocomplete: ElementRef<HTMLInputElement>;
  @ViewChild('nicaDataGrid', { static: false }) nicaDataGrid: NicaDataGridComponent;

  @Input() fieldData = null;
  @Input() dataSetValue = null
  @Input() dataInput = null
  @Input() dataJson = null
  @Input() formGroup = null
  @Input() cssClass = [];
  @Input() tabIndex = 0;
  @Input() labelWidth = null;
  @Input() showRequiredValidation: boolean = false;
  @Input() filterStatic: string = null;

  @Output() emittedButtonDynamicEvent: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() outPutDataGridEvent: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() outputElementValue: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() outputElementInit: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() outputElementFocus: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno

  control: FormControl;
  campoForm: FormGroup;
  typeInput: string = 'text';
  buttonField: ButtonForm
  showSelectBox: boolean = false;
  optionData: any[] = []
  classToHidden: string;
  haveButtonOption: boolean = false;
  haveButtonOptionType2: boolean = false;
  buttonTextArea: boolean = false;
  showClearButton: boolean = false;
  buttonOption: any[];
  buttonOptionType2: any[] = [];
  editorClass: string;
  classEditorContentFocus: string[] = [''];
  typeOfTemplate: any = 'normalInput';
  classA = ''
  campoDescValue: any;
  isNumber: boolean = false
  max: number;
  min: number;
  minValue: any;
  keyValue: string = '';
  firstValue: any;
  errorMessages = {
    'required': 'Campo Richiesto',
  };
  error: string = null;
  zIndex: number;
  readonly: boolean = false
  fieldsSearched: any = [];
  fieldsToSearched: any = [];
  showAutocomplete: boolean = false
  isDX: boolean = true;
  popoverWidth: number;
  targetField: string;
  dataFielToDisplaySearch: any;
  dataFielRelated: any[];
  dataFielValueExprSearch: any;
  checkOk: boolean = false;
  autocompleteSelection: string = 'single';
  isDisabled: boolean = false;
  isUppercase: boolean = false
  pattern: string = '';
  showErrorsPattern: boolean = false
  topPosition: number;
  leftPosition: number;
  titleSetted = ''
  dxComponent: any;
  typeInputMode: string = 'text'
  showButtonPassword: boolean = false;
  dynamicDataSelection: any;
  @HostListener('click', ['$event'])
  onClick(event) {
    if (typeof this.fieldData.dynamic !== 'undefined' &&
      this.fieldData.disableOnUpdate === true &&
      this.fieldData.dynamic.autocomplete === false &&
      this.fieldData.dynamic.buttonOption && event.target && event.target.tagName.toLowerCase() === 'input') {
      event.stopPropagation();
      event.preventDefault();
      console.log('Click bloccato!', this.fieldData);
      console.log('Click bloccato!', event.target.tagName.toLowerCase());
      this.emitButtonDynamic(event, event.target);
      return;
    }
  }

  constructor(
    private anagraficaService: AnagraficaService,
    private formTemplateService: FormsTemplateService,
    private componentService: ComponentService,
    private formBuilder: FormBuilder,
    private _componentFactoryResolver: ComponentFactoryResolver,
    private changeDetector: ChangeDetectorRef,
  ) {

    this.getElementValue = this.getElementValue.bind(this)
    this.focusElement = this.focusElement.bind(this)
  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.fieldData.lista && this.fieldData.customTooltip && this.fieldData.customTooltip.typeContent === 'listaContent' && changes.dataSetValue) {
      if (changes.dataSetValue.currentValue === null) {
        this.fieldData.customTooltip.content = ''
      } else {
        this.getElementValueList(changes.dataSetValue.currentValue, this.fieldData, null, null)
      }
    } else
      if (this.fieldData.dynamic && this.fieldData.customTooltip && this.fieldData.customTooltip.typeContent === 'dynamicContent' && changes.dataSetValue) {
        if (changes.dataSetValue.currentValue === null) {
          this.fieldData.customTooltip.content = ''
        } else {
          this.getElementValue(changes.dataSetValue.currentValue, this.fieldData, null, null)
        }
      } else if (this.fieldData.customTooltip && this.fieldData.customTooltip.typeContent === 'inputValue' && changes.dataSetValue) {
        this.fieldData.customTooltip.content = changes.dataSetValue.currentValue
      }
    if (changes.dataSetValue || changes.firstChange) {

      if (typeof changes.dataSetValue.previousValue != 'undefined') {
        let eventToEmit = {
          value: changes.dataSetValue.currentValue,
          previousValue: changes.dataSetValue.previousValue,
          campo: this.fieldData,
          component: this.input,
          name: 'onValueChanged'
        }

        this.outputElementValue.emit(eventToEmit);

      }

    }

    if (typeof changes.dataSetValue != 'undefined') {

      if (!this.dataInput[this.fieldData.dataField]) {
        return
      }
      let showClearButton = false;

      if (typeof this.fieldData.showClearButton != 'undefined') {
        showClearButton = this.fieldData.showClearButton
      }
      let string = this.dataInput[this.fieldData.dataField].toString()
      if (string.length > 0 && !this.isDisabled && showClearButton) {
        this.showClearButton = true

      }

      if (this.typeInputMode != 'password') {
        this.titleSetted = string
      }


      if (typeof changes.dataSetValue.currentValue == 'object') {

        const data = changes.dataSetValue.currentValue;

        if (Array.isArray(data)) {

          let tipeofDinmaic = typeof this.fieldData.dynamic != 'undefined' ? this.fieldData.dynamic : null

          if (!tipeofDinmaic) {
            return
          }

          let displayExpr = this.fieldData.dynamic.displayExpr;

          if (!displayExpr) {
            return
          }


        }
      }
      //console.log('dataInput[fieldData.dataField]', this.dataInput)
    }



    if (typeof this.fieldData.dynamic != 'undefined') {
      let related = this.fieldData.dynamic.related

      if (related) {

        let valueCampo = this.dataSetValue
        if (this.fieldData.dynamic.valueExpr != '') {

          /* COMMENTATO XKE CON ANTONIO MI SONO RESO CONTO CHE DESCRIZIONE ASSEGNATA NEL MOV, VENIVA SOSTIUITA SEMPRE IN EDIT
         /*  if (valueCampo.length == this.fieldData.maxLength)
            this.getElementValue(valueCampo, this.fieldData, this.input, null) */
        }


      }


    }


  }

  ngAfterViewInit() {
    /* this.input.nativeElement.onload(()) => { 

      this.emittedInitializzed(event,this.input)
     
    }); 
    this.input.nativeElement.onload = (event) => {

    } //*/
    this.emittedInitializzed();


    // this.getElementValue(valueCampo, this.fieldData, input, event)


  }

  async ngOnInit() {
    await this.renderEditorItem()
  }

  async renderEditorItem() {
    //    console.log('dataJson-->' +this.fieldData.dataField,this.dataJson)
    if (this.fieldData) {

      /**se usi devExtreme**/
      if (typeof this.dataSetValue == 'undefined') {
        this.dataSetValue = null
      }

      switch (this.fieldData.editorType) {
        case 'dxNumberBox':
          this.isNumber = true;
          this.typeInput = 'number';
          break;
        case 'number':
          this.isNumber = true;
          this.typeInput = 'number';
          break;

        case 'dxDateBox':
          this.typeInput = 'date';
          this.typeOfTemplate = 'dateInput'
          if (this.fieldData.dataType == 'date') {
            this.typeInput = 'date';
          } else if (this.fieldData.dataType == 'time') {
            this.typeInput = 'time';
          }
          break;
        case 'iconStateVisual':
        case 'iconState':
          this.editorClass = 'form-check-state'
          this.typeInput = 'visualState';
          this.typeOfTemplate = 'visualState';

          break;
        case 'dxCheckBox':
          this.editorClass = 'form-check-input'
          this.typeInput = 'checkbox';
          this.typeOfTemplate = 'checklInput';

          break;

        case 'checkBox':
          this.editorClass = 'form-check-input'
          this.typeInput = 'checkbox';
          this.typeOfTemplate = 'checklInput'

          break;
        case 'dxRadioGroup':

          this.typeInput = 'radio';
          this.typeOfTemplate = 'radioInput';

          break;
        case 'radioGroup':

          this.typeInput = 'radio';
          this.typeOfTemplate = 'radioInput';

          break;
        case 'dxSelectBox':
        case typeof this.fieldData.lista != 'undefined':
          if (typeof this.fieldData.lista != 'undefined') {
            this.showSelectBox = true;
            this.typeOfTemplate = 'selectInput'
            this.fieldData.lista.placeholder = 'Seleziona..';

          }

          break;

        case 'selectBox':

          if (typeof this.fieldData.lista != 'undefined') {
            this.showSelectBox = true;
            this.typeOfTemplate = 'selectInput'
            this.fieldData.lista.placeholder = 'Seleziona..';
            //this.getDataSource(this.fieldData.lista)
            //            ////console.log(this.optionData)
          }

          break;

        case 'dxTextArea':

          this.typeOfTemplate = 'textArea'

          break;
        case 'textAreaWithBtn':
          this.typeOfTemplate = 'textAreaWithBtn'
          break;
        case 'switch':
          this.typeOfTemplate = 'switchInput'
          this.editorClass = 'form-check-input'
          this.typeInput = 'checkbox';
          break;
        case 'switchBox':
          this.typeOfTemplate = 'switchInput'
          this.editorClass = 'form-check-input'
          this.typeInput = 'checkbox';
          break;
        case 'dxSwitchBox':
          this.typeOfTemplate = 'switchInput'
          this.editorClass = 'form-check-input'
          this.typeInput = 'checkbox';
          break;
        case 'textBoxArea':

          this.typeOfTemplate = 'textBoxArea'

          break;

        case 'dxInputFile':
        case 'inputFile':
          this.typeInput = 'file';
          this.typeOfTemplate = 'inputFile'

          break;

        default:
          break;
      }

      if (this.fieldData.type == 'simpleButton') {
        this.typeOfTemplate = 'buttonInput'

        this.buttonField = this.fieldData.button;

      }

      if (this.fieldData.type == 'divider') {
        this.typeOfTemplate = 'divider'
      }


      if (this.fieldData.type == 'campoDesc') {
        this.typeOfTemplate = 'campoDesc';
        if (!this.dataSetValue) {
          this.campoDescValue = this.fieldData.defaultValue || this.fieldData.placeholder
        } else {
          this.campoDescValue = this.dataSetValue
        }
      }

      if (this.fieldData.editorType == 'textBox' && this.fieldData.type == 'campoSpecial') {
        // console.log( 'vedi fieldData', this.fieldData.dataField,this.fieldData.editorType);
        this.typeInput = 'text';
        this.typeOfTemplate = 'normalInput'
        this.fieldData.mode = 'text';
        this.typeInputMode = 'text';
      }

      this.editorClass = 'simple-texteditor-input'

      if (this.fieldData.type == 'campoPassword') {
        this.showButtonPassword = true;
        this.fieldData.mode = 'password'
        this.typeInputMode = 'password';
        this.titleSetted = ''
      }

      if (this.fieldData.hideOnEdit || this.fieldData.class == 'd-none' || this.fieldData.type == 'campoHidden') {
        this.typeInput = 'hidden';
        this.classToHidden = 'd-none'
        this.typeOfTemplate = 'hiddenInput'
      }
      if (this.fieldData.uppercase) {
        this.isUppercase = true;
      }

      if (!this.fieldData.placeHolder) {
        this.fieldData.placeHolder = '';

      }

      if (this.fieldData.patterns) {
        this.pattern = this.fieldData.patterns;

      }
      if (this.fieldData.helpText) {
        this.titleSetted = this.fieldData.helpText;

      }
      if (this.fieldData.dynamic && this.fieldData.customTooltip && this.fieldData.customTooltip.typeContent === 'dynamicContent' && this.dataSetValue) {
        if (this.dataSetValue === null) {
          this.fieldData.customTooltip.content = ''
        } else {
          this.getElementValue(this.dataSetValue, this.fieldData, null, null)
        }
      } else if (this.fieldData.customTooltip && this.fieldData.customTooltip.typeContent === 'inputValue' && this.dataSetValue) {
        this.fieldData.customTooltip.content = this.dataSetValue
      }
      if (typeof this.formGroup == 'undefined') {

        this.formGroup = null

        //this.formGroupName = this.formBuilder.group(formGroupFields);
      }

      if (this.fieldData.disabled) {
        if (this.fieldData.type != "simpleButton") {

          this.formGroup.get(this.fieldData.dataField).disable();
        }

        this.cssClass.push('nica-disabled');
        this.tabIndex = -1;
        this.isDisabled = true;
      }

      if (this.fieldData.dynamic) {

        if (typeof this.fieldData.dynamic.buttonOption != 'undefined') {
          const dynamicButtonOption = this.fieldData.dynamic.buttonOption
          this.haveButtonOption = true;

          this.buttonOption = [
            {
              text: dynamicButtonOption.text,
              icon: dynamicButtonOption.icon,
              hint: dynamicButtonOption.hint,
              name: dynamicButtonOption.name,
              /* disabled: this.fieldData.disabled */

            }
          ]

        }



        if (typeof this.fieldData.dynamic.buttons != 'undefined') {
          const buttonsOption = this.fieldData.dynamic.buttons
          this.haveButtonOptionType2 = true;

          buttonsOption.forEach(buttonOption => {
            this.buttonOptionType2.push({
              text: buttonOption.text,
              icon: buttonOption.icon,
              hint: buttonOption.hint,
              name: buttonOption.name,
              visible: buttonOption.visible,
              disabled: buttonOption.disabled
            })
          })

        }

      }

      if (typeof this.fieldData.button != 'undefined') {

        const buttonOption = this.fieldData.button
        this.haveButtonOptionType2 = true;


        this.buttonOptionType2.push(
          {
            text: buttonOption.text,
            icon: buttonOption.icon,
            hint: buttonOption.hint,
            name: buttonOption.name,
            disabled: buttonOption.disabled
            /* disabled: this.fieldData.disabled */
          }
        )



      }
      //      ////console.log('fieldData', this.fieldData)
      if (typeof this.fieldData.buttons != 'undefined') {

        const buttonsOption = this.fieldData.buttons
        this.haveButtonOptionType2 = true;

        buttonsOption.forEach(buttonOption => {
          this.buttonOptionType2.push({
            text: buttonOption.text,
            icon: buttonOption.icon,
            hint: buttonOption.hint,
            name: buttonOption.name,
            visible: buttonOption.visible,
            /*  disabled: this.fieldData.disabled || buttonOption.disabled */
          })
        })





      }
      if (typeof this.fieldData.editorType !== undefined && this.fieldData.editorType === "textAreaWithBtn") {
        this.buttonTextArea = true
      }

    }

    if (typeof this.fieldData.labelWidth != 'undefined') {
      this.labelWidth = this.fieldData.labelWidth
    }

    let dataField = this.fieldData.dataField;

    if (typeof this.formGroup.controls[dataField] != 'undefined') {
      this.control = this.formGroup.controls[dataField]
    }

    if (typeof this.formGroup.controls[dataField] == 'undefined') {
      //console.log('Questo controls non esiste-->' + dataField,this.formGroup)
    }

  }



  isSelected(ev) {
    ////console.log(ev)
    if (ev == this.dataSetValue) {
      return 'selected'
    }
  }


  /****FUNZIONI LEGATE A GLI EVENTI****/

  emitButtonDynamic(ev, input) {
    console.log('dataJson--III', this.dataJson)
    let event = this.fieldData

    event.event = ev;
    event.name = 'beforeEmitButtonDynamic'
    event.cancel = false;
    event.editor = this

    this.emittedButtonDynamicEvent.emit(event)

    if (event.cancel) {
      return
    }

    let componentType = this.fieldData.dynamic.componentType;
    let dataz = this.fieldData
    let isPureComponent = false;

    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === componentType);
    if (typeof factoryClass != 'undefined') {
      if (factoryClass.name == componentType) {
        isPureComponent = true;
      }
    }

    if (componentType == 'dynamicGrid') {
      componentType = 'NicaDataGridComponent'
      isPureComponent = true;

    }


    if (isPureComponent) {
      if (typeof dataz.dynamic.queryString != 'undefined') {
        // crea un'espressione regolare per cercare "$filter=(...)"
        let regexFilter = /\$filter=\([^]*\)*/;
        let regexFilterOrderBy = /\$orderby=([^&]+)/;

        // Esegui la ricerca nella stringa
        let checkQuery = dataz.dynamic.queryString.match(regexFilter);
        let checkQueryO = dataz.dynamic.queryString.match(regexFilterOrderBy);
        let query = dataz.dynamic.queryString
        let isErrorQuery = true
        // Verifica se c'è una corrispondenza
        if (checkQuery) {
          query = query.replace(regexFilter, '');
        }

        if (checkQueryO) {
          query = query.replace(regexFilterOrderBy, '');
        }



        if (query.includes('$')) {

          for (let x in this.dataInput) {
            if (x) {
              let regex = new RegExp('\\$' + x + '\\b', 'g');
              if (query.match(regex)) {


                if (typeof this.dataInput[x] !== 'undefined' && this.dataInput[x] !== null) {
                  isErrorQuery = false;

                }



              }
            }



          }
          if (isErrorQuery)
            //alert('Selezionare prima: ' + ((label) ? label : arrQuerySTemp[1]), 'Attenzione!');
            return

        }



      }
      if (componentType == 'dynamicGrid' || componentType == 'NicaDataGridComponent') {
        componentType = 'NicaDataGridComponent'
        isPureComponent = true;
        this.openComponentGrid(componentType, dataz);
        return
      } else {
        let event = {
          event: ev,
          component: componentType,
          campo: dataz,
          name: 'buttonDynamicOpenComponent'

        }

        this.emittedButtonDynamicEvent.emit(event)
        return
      }



    }
  }

  emitButtonType2(ev, button) {
    ////console.log('emitButtonDynamic', ev)
    //let event = this.fieldData

    let event = this.fieldData
    event.event = ev;
    event.name = 'emitButtonType2'
    event.button = button
    event.event = ev;


    this.emittedButtonDynamicEvent.emit(event)
  }

  onFocusInEvent(event?) {

    this.classEditorContentFocus.push('state-active')

    const rect = document.getElementById(this.fieldData.dataField).getBoundingClientRect() as DOMRect;
    this.topPosition = rect.top + window.scrollY; // Calcola la posizione verticale dell'input

    this.leftPosition = rect.left + window.scrollX; // Calcola la posizione orizzontale dell'input
  }

  onFocusOutEvent(event, input) {

    if (this.showAutocomplete) {
      if (this.fieldsSearched.length > 0 && !this.checkOk) {

        input.focus();
        return
      } else if (this.fieldsSearched.length == 0) {
        event.target.value = null
        this.showAutocomplete = false;

      } else if (this.checkOk) {

        this.showAutocomplete = false;

      }

    }

    if (typeof this.dataInput[this.fieldData.dataField] == 'object') {
      this.classEditorContentFocus = [''];
      return
    }
    let valueCampo = event.target.value
    let campo = this.fieldData;
    this.classEditorContentFocus = [''];
    ////console.log('control-->', this.control)

    this.validateElement(input)

    if (typeof campo.dynamic != 'undefined') {



      let event = {
        valueCampo: valueCampo,
        campo: campo,
        name: 'onFocusOut',
        cancel: false
      }

      this.outputElementValue.emit(event)

      if (!event.cancel) {

        if (typeof this.fieldData.dynamic != 'undefined') {
          /***SE IL autocomplete E IMPOSTATO FARE LA CHIAMATA getElementValue PER OTTENERE LA DESCRIZIONE NEL CAMPO RELAZIONATO***/
          if (this.fieldData.dynamic.autocomplete)
            this.getElementValue(valueCampo, this.fieldData, input, event)

        }
      }

      return




    }


  }

  onFocusInDXEvent(event) {

    this.classEditorContentFocus = ['state-active'];

    if (typeof this.dxComponent != 'undefined') {
      this.dxComponent.focus()
    }
  }

  onFocusOutDXEvent(event) {

    this.classEditorContentFocus = [''];

    let eventT = {
      dataField: this.fieldData.dataField,
      campo: this.fieldData,
      editorComponent: this,
      event: event
    }

    this.outputElementFocus.emit(eventT)
  }

  onLoadEvent(event) {
    ////console.log('onLoadEvent', event);
    return;

  }

  onBeforeinputNumber(event, input) {

    const functionalKeys = ['Backspace', 'ArrowRight', 'ArrowLeft'];

    if (functionalKeys.indexOf(event.data) !== -1) {
      return;
    }

    if (this.isNumber) {
      let newValue = input.value;
      let maxLength = Number(this.fieldData.maxLength)
      if (newValue.length > maxLength) {
        input.value = Number(newValue.slice(0, maxLength));
        //event.target.value = newValue.slice(0, maxLength);
        this.dataInput[this.fieldData.dataField] = Number(newValue);
        event.stopPropagation();
        event.preventDefault();
        return
      }


    }

    let eventToEmit = {
      value: input.value,
      campo: this.fieldData,
      component: input,
      name: 'onValueChanged'
    }

    this.outputElementValue.emit(eventToEmit);





  }


  onBeforeinputText(event, input) {

    ////console.log('onBeforeinputText-->', event)



    let eventToEmit = {
      value: input.value,
      campo: this.fieldData,
      component: input,
      name: 'onValueChanged'
    }

    this.outputElementValue.emit(eventToEmit);


    if (!input.value) {
      //this.control.setErrors({ 'pattern': null }); // Rimuovi gli errori se il pattern è soddisfatto
      this.showErrorsPattern = false;
      return
    }


  }

  onChange(event, input) {
    ////console.log('onChange-->', event)
    /* if(typeof this.fieldData.dynamic != 'undefined'){
      if(this.fieldData.dynamic.valueExpr != ''){
        this.getElementValue(input.value, this.fieldData, input,event)
      }
        
    } */

    this.validateElement();


  }

  onKeyUp(event, input) {

    ////console.log('onKeyUp-->', event)
    ////console.log('onKeyUpinput-->', input)
    const functionalKeys = ['Backspace', 'ArrowRight', 'ArrowLeft'];


    if (functionalKeys.indexOf(event.key) !== -1) {
      return;
    }






  }
  onKeyDown(event, input) {

    if (event.key === "+") return;

    console.log("Controllo carattere")
    if (this.showAutocomplete) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter') {
        this.autocompleteFromPopOver(event.key);
        return
      }
    }
    //return
    //
    if (
      (event.keyCode > 112 && event.keyCode < 124) ||
      (event.keyCode >= 16 && event.keyCode < 20) ||
      [8, 46, 37, 39, 38, 40, 9].includes(event.keyCode)
    ) {
      //
      // /[0-9]/ /^[a-zA-Z0-9]$/
    } else {
      if (this.fieldData.editorType == "textBox" && this.fieldData.acceptOnlyCharacters) {
        const allowedPattern = this.fieldData.acceptOnlyCharacters;

        let result = allowedPattern;
        result = result.substring(1, result.length - 1)
        var test = new RegExp(result, 'm');
        var st = "" + event.key;
        if (!st.match(test)) {
          //event.key = null
          event.preventDefault();
          return false;
        }
      }

    }

    let eventToEmit = {
      value: input.value,
      campo: this.fieldData,
      component: input,
      name: 'onKeyDown'
    }

    this.outputElementValue.emit(eventToEmit);

  }


  updateFiedlFromGridSelection(data, datafield, displayExprItem, valueExprItem, realtedItem, component?, input?, keyPressed?: string) {

    if (data) {
      let previusValue = input.value
      let valueExpr = valueExprItem;
      let displayExpr = displayExprItem
      let value
      if (Array.isArray(displayExpr)) {
        let val = []
        displayExpr.forEach(res => {
          if (data[res]) {
            let value1 = data[res]

            let dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
            let isMatch = dateType.test(value1);

            if (isMatch) {
              value1 = this.formatDate(value1, 'it')
            }

            val.push(value1)
          }

        })
        value = val.join(' - ');
      } else {
        if (data[valueExpr]) {
          let value2 = data[valueExpr]
          value = value2;
        }

      }

      if (!value) {
        return
      }


      let key = datafield;

      /***Se ci sono campi relazionari***/

      let related = realtedItem

      /***************************************/
      const keyVariable = key;
      const valueArray = value;

      this.dataInput[key] = value;



      if (related) {

        let newItem;
        let newItemDesc;
        related.forEach((values, key) => {
          let arrayValue = values.split('|')
          if (arrayValue.length > 1) {
            this.dataInput[arrayValue[1]] = data[arrayValue[0]]
          } else {
            this.dataInput[values] = data[values]
          }

        })

      }

      if (component) {


        this.componentService.destroyOutputComponent()
        this.componentService.destroyCurrentOpenPopUpByGuid(component);


      }
      setTimeout(() => {
        input.focus()
        this.validateElement();
        if (this.dataInput[key] != null) {
          this.checkOk = true
        }


      }, 500);

      let eventToEmit = {
        value: this.dataInput[key],
        previousValue: previusValue,
        campo: this.fieldData,
        component: this.input,
        name: 'onValueChangedAfterGridSelect'
      }

      this.outputElementValue.emit(eventToEmit);

      if (typeof keyPressed == 'string') {


        if (keyPressed == 'Enter')
          this.showAutocomplete = false;

      }

    }
  }

  selectedEventInitialized(event) {

    //console.log('selectedEventInitialized', event)
    //////console.log('selectedEventnativeElement', this.input.nativeElement,)
    this.input = event.nativeElement;

    this.dxComponent = event.dxComponent;

    let eventToEmit = {
      name: 'onInitialized',
      htmlElement: this.input,
      onInitialized: event,
      campo: this.fieldData,
      component: event.editorComponent,
      dxComponent: event.dxComponent,
      editorComponent: this,
    }
    if (event.value !== undefined && event.value !== null) {
      eventToEmit['value'] = event.value
    }
    this.outputElementInit.emit(eventToEmit)

  }

  inputCheckBoxInitialized(event) {

    console.log('inputCheckBoxInitialized', event)
    //////console.log('selectedEventnativeElement', this.input.nativeElement,)

    if (typeof event.nativeElement != 'undefined') {
      this.input = event.nativeElement;
    } else {
      this.input = event;
    }

    if (typeof event.nativeElement != 'undefined') {
      this.input = event.nativeElement;
    } else {
      this.input = event;
    }

    let eventToEmit = {
      name: 'onInitialized',
      htmlElement: this.input,
      onInitialized: event,
      campo: this.fieldData,
      dxComponent: event.dxComponent,
      component: event.editorComponent,

      editorComponent: this,
    }
    if (event.value !== undefined && event.value !== null) {
      eventToEmit['value'] = event.value
    }
    this.outputElementInit.emit(eventToEmit)
  }

  inputDataInitialized(event) {

    if (typeof event.nativeElement != 'undefined') {
      this.input = event.nativeElement;
    } else {
      this.input = event;
    }

    let eventToEmit = {
      name: 'onInitialized',
      htmlElement: this.input,
      onInitialized: event,
      campo: this.fieldData,
      dxComponent: event.dxComponent,
      component: event.editorComponent,
      editorComponent: this,
    }
    this.outputElementInit.emit(eventToEmit)

    //this.emittedInitializzed()
  }

  selectedEvent(event) {

    if (event.name == 'selectChange') {
      let key = event.dataField;
      this.dataInput[key] = event.value;

    }

    event.campo = this.fieldData
    this.outputElementValue.emit(event)


    //////console.log('selectedEventnativeElement', this.input.nativeElement,)

  }

  inputCheckBox(event) {

    if (event.name == 'checkBoxChange') {
      let key = event.dataField;
      this.dataInput[key] = event.value;

      let eventToEmit = {
        value: event.value,
        campo: this.fieldData,
        component: event.component,
        name: 'onValueChanged'
      }

      this.outputElementValue.emit(eventToEmit);

    }

    //////console.log('selectedEventnativeElement', this.input.nativeElement,)

  }

  inputDataBox(event) {

    if (event.name == 'onValueChangedDateTime') {
      let key = event.dataField;
      this.dataInput[key] = event.value;

      let eventToEmit = {
        value: event.value,
        campo: this.fieldData,
        component: event.component,
        name: 'onValueChanged'
      }

      this.outputElementValue.emit(eventToEmit);

    }

    //////console.log('selectedEventnativeElement', this.input.nativeElement,)

  }

  inputRadioGroupInitialized(event) {

    this.input = event.nativeElement;

    this.dxComponent = event.dxComponent;

    let eventToEmit = {
      name: 'onInitialized',
      htmlElement: this.input,
      onInitialized: event,
      campo: this.fieldData,
      component: event.editorComponent,
      editorComponent: this,
    }
    console.log(eventToEmit)
    this.outputElementInit.emit(eventToEmit)
  }

  inputRadioBox(event) {
    if (event.name == 'radioGroupChange') {
      let key = event.dataField;
      this.dataInput[key] = event.value;

      let eventToEmit = {
        value: event.value,
        campo: this.fieldData,
        component: event.component,
        name: 'onValueChanged'
      }
      // console.log(eventToEmit)

      this.outputElementValue.emit(eventToEmit);
    }
  }
  inputSwitchBox(event) {
    if (event.name == 'switchGroupChange') {
      let key = event.dataField;
      this.dataInput[key] = event.value;

      let eventToEmit = {
        value: event.value,
        campo: this.fieldData,
        component: event.component,
        name: 'onValueChanged'
      }

      this.outputElementValue.emit(eventToEmit);
    }
  }
  inputSwitchGroupInitialized(event) {

    this.input = event.nativeElement;

    this.dxComponent = event.dxComponent;
    let eventToEmit = {
      name: 'onInitialized',
      htmlElement: this.input,
      onInitialized: event,
      campo: this.fieldData,
      value: event.value,
      component: event.editorComponent,
      editorComponent: this,
    }
    console.log(eventToEmit)
    this.outputElementInit.emit(eventToEmit)
  }

  emittedInitializzed() {
    let event = {}
    if (typeof this.input == 'undefined' && typeof this.textArea == 'undefined') {
      return
    } else if (typeof this.input == 'undefined' && typeof this.textArea !== 'undefined') {
      event = {
        name: 'onInitialized',
        htmlElement: this.textArea.nativeElement,
        component: this,
        onInitialized: null,
        dxComponent: null,
        campo: this.fieldData,
        editorComponent: this,
      }
    } else if (typeof this.textArea == 'undefined' && typeof this.input !== 'undefined') {
      event = {
        name: 'onInitialized',
        htmlElement: this.input.nativeElement,
        component: this,
        onInitialized: null,
        dxComponent: null,
        campo: this.fieldData,
        editorComponent: this,
      }
    }




    this.outputElementInit.emit(event)

    if (this.fieldData.disableOnUpdate || this.fieldData.readOnly || this.fieldData.nonEditabile) {
      // this.readonly = true;
      this.input.nativeElement.setAttribute('readonly', 'readonly');
    }



  }

  /****FINE FUNZIONI LEGATE A GLI EVENTI****/

  public validateElement(input?) {

    this.classEditorContentFocus = this.classEditorContentFocus.filter(res => res != 'invalid');

    for (let propertyName in this.control.errors) {
      if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {

        this.zIndex = this.getMaxZIndex + 1;
        this.classEditorContentFocus.push('invalid');

        if (input) {
          //input.focus();
        }


      } else {
        this.classEditorContentFocus = this.classEditorContentFocus.filter(res => res != 'invalid');

      }
    }
    if (this.pattern) {
      this.validatePattern()
    }


  }

  validatePattern() {

    /*     this.showErrorsPattern = false;
        this.control.setErrors({ 'pattern': null });
    
    
        const value = this.control.value;
        this.control.setErrors({ 'pattern': false });
    
        if (!value) {
          this.control.setErrors({ 'pattern': false }); // Rimuovi gli errori se il pattern è soddisfatto
          this.showErrorsPattern = false;
          return
        }
    
        const pattern = new RegExp(this.pattern); // Crea l'espressione regolare dal pattern
    
    
        if (pattern.test(value)) {
          this.control.setErrors({ 'pattern': false }); // Rimuovi gli errori se il pattern è soddisfatto
          this.control.setErrors(null)
        } else {
          this.control.setErrors({ 'pattern': true }); // Imposta l'errore se il pattern non è soddisfatto
        }
    
    
        if (this.control.errors.pattern) {
          this.showErrorsPattern = true;
          //document.getElementById('errorsPattern').style.top = 27 + 'px'
    
        } */
    //! ------------------- NON FUNZIONA NIENTE DI QUESTO USARE I VALIDATORS:[{type:'',value:'',message:''}]
  }
  /****FUNZIONI UTILITY****/
  clearData(ev?) {

    this.input.nativeElement.value = null;
    this.dataInput[this.fieldData.dataField] = null
    this.showClearButton = false;

    let related = typeof this.fieldData.dynamic != 'undefined' ? this.fieldData.dynamic.related : null
    if (related) {
      let data = this.dataInput
      let newItem;
      let newItemDesc;
      related.forEach((values, key) => {
        let arrayValue = values.split('|')
        if (arrayValue.length > 1) {
          this.dataInput[arrayValue[1]] = null
        } else {
          this.dataInput[values] = null
        }

      })

    }


  }


  showPassword(e, input) {
    let inputPssword = this.input.nativeElement
    if (inputPssword.type == "password") {
      inputPssword.type = "text";
      this.typeInputMode = "text";
    } else {
      inputPssword.type = "password";
      this.typeInputMode = "password"
    }
  }

  getElementValueList(value, campo, input, event) {
    //  //////console.log( evento + ' - '+ value,campo.dataField)
    if (value) {
      let rel = ''
      let queryString
      if (campo.lista.static === true) {
        let res = this.formTemplateService.getDati(this.fieldData.lista.dataSource)

        const id = 'P';
        const current = res.find(s => s[campo.lista.displayExpr] === value);


        if (this.fieldData.customTooltip && this.fieldData.customTooltip.dynamicContent && this.fieldData.customTooltip.typeContent === 'listaContent') {
          const dataFieldDisplay = this.fieldData.customTooltip.dynamicContent.match(/\$(\w+)/)[1]
          this.fieldData.customTooltip.content = current[dataFieldDisplay]
        }
        return;
      }
      if (campo.lista.queryString) {
        if (campo.lista.queryString.includes('$')) {
          let arrQuerySTemp = campo.lista.queryString.split('$');

          let query = arrQuerySTemp[0];
          let filter = ''
          const dataSet = arrQuerySTemp[1].split('&')[0];
          if (dataSet == campo.dataField) {
            filter = value;
            value = '';
          } else {
            if (typeof this.dataInput[dataSet] != 'undefined') {

              filter = this.dataInput[dataSet];
            }
          }



          if (typeof filter != 'undefined') {
            queryString = query + filter
          }

        } else {
          queryString = campo.lista.queryString
        }
      }

      this.anagraficaService.getValue(campo.lista.dataSource, value, queryString).then(res => {



        if (res['items']) {
          res = res['items']
        }

        let related = campo.lista.related
        this.dynamicDataSelection = res
        if (this.fieldData.customTooltip && this.fieldData.customTooltip.dynamicContent && this.fieldData.customTooltip.typeContent === 'listaContent') {
          const dataFieldDisplay = this.fieldData.customTooltip.dynamicContent.match(/\$(\w+)/)[1]
          if (Array.isArray(this.dynamicDataSelection)) {
            this.fieldData.customTooltip.content = this.dynamicDataSelection.filter((item) => item[this.fieldData.lista.valueExpr] === value)[0][dataFieldDisplay]
          } else {
            this.fieldData.customTooltip.content = this.dynamicDataSelection[dataFieldDisplay]
          }
        }
        /***************************************/




        if (related) {

          related.forEach((values, key) => {
            let arrayValue = values.split('|')
            if (arrayValue.length > 1) {
              this.dataInput[arrayValue[1]] = res[arrayValue[0]]
            } else {
              this.dataInput[values] = res[values]
            }

          })

        }

      }).catch(error => {
        //this.input.nativeElement.focus()
        //////console.log(error)
        //alert('Valore inesistente');

        //        event.stopPropagation()
        // event.preventDefault();
        /*  setTimeout(() => {
 
           //this.dataInput[this.fieldData.dataField] = this.firstValue
           
         }, 200); */

        return

      })


    }

  }
  getElementValue(value, campo, input, event) {
    //  //////console.log( evento + ' - '+ value,campo.dataField)
    if (value) {
      let rel = ''


      let queryString
      if (campo.dynamic.queryString) {
        if (campo.dynamic.queryString.includes('$')) {
          let arrQuerySTemp = campo.dynamic.queryString.split('$');

          let query = arrQuerySTemp[0];
          let filter = ''
          const dataSet = arrQuerySTemp[1].split('&')[0];
          if (dataSet == campo.dataField) {
            filter = value;
            value = '';
          } else {
            if (typeof this.dataInput[dataSet] != 'undefined') {

              filter = this.dataInput[dataSet];
            }
          }



          if (typeof filter != 'undefined') {
            queryString = query + filter
          }

        } else {
          queryString = campo.dynamic.queryString
        }
      }

      this.anagraficaService.getValue(campo.dynamic.dataSource, value, queryString).then(res => {



        if (res['items']) {
          res = res['items']
        }

        let related = campo.dynamic.related
        this.dynamicDataSelection = res
        if (this.fieldData.customTooltip && this.fieldData.customTooltip.dynamicContent && this.fieldData.customTooltip.typeContent === 'dynamicContent') {
          const dataFieldDisplay = this.fieldData.customTooltip.dynamicContent.match(/\$(\w+)/)[1]
          this.fieldData.customTooltip.content = this.dynamicDataSelection[dataFieldDisplay]
        } else if (this.fieldData.customTooltip && this.fieldData.customTooltip.typeContent === 'inputValue') {
          this.fieldData.customTooltip.content = this.dataSetValue
        }
        /***************************************/




        if (related) {

          related.forEach((values, key) => {
            let arrayValue = values.split('|')
            if (arrayValue.length > 1) {
              this.dataInput[arrayValue[1]] = res[arrayValue[0]]
            } else {
              this.dataInput[values] = res[values]
            }

          })

        }

      }).catch(error => {
        //this.input.nativeElement.focus()
        //////console.log(error)
        //alert('Valore inesistente');

        //        event.stopPropagation()
        // event.preventDefault();
        /*  setTimeout(() => {
 
           //this.dataInput[this.fieldData.dataField] = this.firstValue
           
         }, 200); */

        return

      })


    }

  }

  focusElement() {

  }

  get getMaxZIndex() {
    return Math.max(
      ...Array.from(document.querySelectorAll('body *'), el =>
        parseFloat(window.getComputedStyle(el).zIndex),
      ).filter(zIndex => !Number.isNaN(zIndex)),
      0,
    );
  }


  gettedLabel(dataF) {
    let control = this.formGroup.get(dataF)
    const parent = this.formGroup.parent;

    if (parent instanceof FormGroup) {
      // Ottieni il nome del controllo all'interno del FormGroup
      const formGroupName = Object.keys(parent.controls).find(name => parent.controls[name] === control);



      if (formGroupName) {
        // Trova l'elemento del label tramite il selettore `[for="controlName"]`
        const labelElement = document.querySelector(`[for="${formGroupName}"]`);
        return labelElement.textContent

      }
      return null;
    }
  }

  /****FINE FUNZIONI UTILITY****/

  /****I MIE METODI PER RENDERE I CAMPI ANCORA PIù DINAMICI ****/

  openComponentGrid(component, data) {

    let dataFilter;
    if (data.dynamic.costantValue) {

      const costantValue = data.dynamic.costantValue;
      let values
      costantValue.forEach(element => {
        let keyEle = element['key'];
        let val = ''
        if (typeof this.dataInput[element['value']] != 'undefined') {
          val = this.dataInput[element['value']]
        } else {
          val = element['value']
        }

        values = { ...values, [keyEle]: val }
      })
      dataFilter = JSON.stringify(values)

    }


    let title = ''


    let settingGrid = {
      isEditable: false,
      allowUpdating: false,
      allowDeleting: false,
      allowAdding: false,
      searchAndSelect: false,
      selectionMode: 'single',
      tableHeight: '630',
      tableWidth: '700',
      remoteOperations: true,
      showFilter: false,
      colonne: [],
      idTable: '0',
      rowAlternationEnabled: true,
      showToolbarTop: false,
      showToolbarBottom: false,
      toolbarButtonsTopLeft: null,
      toolbarButtonsTopRight: null,
      toolbarButtonsBottomLeft: null,
      toolbarButtonsBottomRight: null,
      isOdata: true,
      searchType: 'contains',
      overrideDataSource: null,
      concatDataField: null,
      minSearch: undefined
    }

    let campoDynamic = data.dynamic;
    let isToolbarButtonsTop = false;
    let isToolbarButtonsBottom = false;

    if (typeof campoDynamic.settingGrid != 'undefined') {
      let sGrid = campoDynamic.settingGrid;
      let isEditable = (sGrid.allowAdding || sGrid.allowDeleting || sGrid.allowUpdating) ? true : false;
      let showToolbarTop = isEditable ? true : false;
      let tableWidth = typeof sGrid.width == 'undefined' ? 700 : sGrid.width;
      isToolbarButtonsBottom = typeof sGrid.toolbarButtonsBottomLeft != 'undefined' || typeof sGrid.toolbarButtonsBottomRight != 'undefined' ? true : false;
      isToolbarButtonsTop = typeof sGrid.toolbarButtonsTopLeft != 'undefined' || typeof sGrid.toolbarButtonsTopRight != 'undefined' ? true : false;

      settingGrid = {
        isEditable: isEditable,
        allowUpdating: sGrid.allowUpdating,
        allowDeleting: sGrid.allowDeleting,
        allowAdding: sGrid.allowAdding,
        selectionMode: sGrid.selectionMode,
        tableHeight: sGrid.height,
        tableWidth: tableWidth,
        remoteOperations: sGrid.remoteOperations,
        showFilter: sGrid.showFilterSearch,
        searchAndSelect: sGrid.searchAndSelect,
        colonne: sGrid.colonne,
        showToolbarTop: showToolbarTop,
        showToolbarBottom: sGrid.showToolbarBottom,
        rowAlternationEnabled: sGrid.rowAlternationEnabled,
        isOdata: sGrid.isOdata,
        idTable: Math.random().toString().replace("0.", ""),
        toolbarButtonsTopLeft: sGrid.toolbarButtonstopLeft,
        toolbarButtonsTopRight: sGrid.toolbarButtonsTopRight,
        toolbarButtonsBottomLeft: sGrid.toolbarButtonsBottomLeft,
        toolbarButtonsBottomRight: sGrid.toolbarButtonsBottomRight,
        searchType: sGrid.searchType,
        overrideDataSource: sGrid.overrideDataSource,
        concatDataField: sGrid.concatDataField,
        minSearch: sGrid.minSearch,
      }

    }


    title = campoDynamic.caption
    let showCaptionFooter = true;
    let showToolbarBottom = false
    let showCaptionHeader = true;

    let popupWidth = data.dynamic.popupWidth ? data.dynamic.popupWidth : settingGrid.tableWidth;
    let popupHeight = data.dynamic.popupHeight ? data.dynamic.popupHeight : 600;

    let justSelectedData = [];

    if (settingGrid.selectionMode == 'multiple') {
      let dataFieldSel = data.dataField
      if (typeof settingGrid.concatDataField != 'undefined') {
        if (settingGrid.concatDataField) {
          dataFieldSel = settingGrid.concatDataField
        }
      }
      if (typeof this.dataInput[dataFieldSel] != 'undefined') {
        justSelectedData = this.dataInput[dataFieldSel]
      }

      if (this.dataJson) {
        if (typeof this.dataJson[dataFieldSel] != 'undefined') {
          justSelectedData = this.dataJson[dataFieldSel]
        }
      }

    }

    let overrideDataSource = null
    if (settingGrid.overrideDataSource) {
      if (this.dataJson) {
        if (Object.keys(this.dataJson).length > 0) {
          if (typeof this.dataJson[settingGrid.overrideDataSource] != 'undefined') {
            overrideDataSource = this.dataJson[settingGrid.overrideDataSource];
          }
        }
      }
    }

    if (campoDynamic.componentType != 'dynamicGrid') {
      showCaptionFooter = false;
      showToolbarBottom = true;
      showCaptionHeader = false;
      popupWidth = null
    }

    if (campoDynamic.componentType == 'dynamicGrid' || campoDynamic.componentType == 'NicaDataGridComponent') {
      showCaptionFooter = true;
      showToolbarBottom = true;
      showCaptionHeader = true;
      //popupWidth = null
    }

    if (isToolbarButtonsBottom) {
      settingGrid.showToolbarBottom = true;
      showToolbarBottom = false;
      showCaptionFooter = false
    }
    if (isToolbarButtonsTop) {
      settingGrid.showToolbarTop = true;
    }

    let queryString = '';
    if (typeof campoDynamic.queryString != 'undefined') {
      queryString = campoDynamic.queryString
    }

    let filterStatic = '';
    if (typeof campoDynamic.filterStatic != 'undefined') {
      filterStatic = campoDynamic.filterStatic;
    }

    let detailOption = null

    if (typeof campoDynamic.detailOption != 'undefined') {

      let sGridDetail = campoDynamic.detailOption;


      detailOption = {
        isRemote: sGridDetail.isRemote,
        service: sGridDetail.service,
        api: sGridDetail.api,
        isEditable: sGridDetail.isEditable,
        costantValue: sGridDetail.costantValue,
        queryString: sGridDetail.queryString,
        colonne: sGridDetail.colonne

      }

    }



    let instancedDataGrid = {
      service: campoDynamic.service,
      api: campoDynamic.dataSource,
      api_rest: campoDynamic.api_rest,
      remoteOperation: settingGrid.remoteOperations,
      rowAlternate: true,
      dataJson: dataFilter,
      queryString: queryString,
      filterStatic: filterStatic,
      isEditable: settingGrid.isEditable,
      isEditableNewRow: settingGrid.allowAdding,
      isEditableEditRow: settingGrid.allowUpdating,
      isEditableDeleteRow: settingGrid.allowDeleting,
      tableHeight: settingGrid.tableHeight,
      tableWidth: settingGrid.tableWidth,
      showFilter: settingGrid.showFilter,
      searchType: settingGrid.searchType,
      colonne: settingGrid.colonne,
      selectionRowMode: settingGrid.selectionMode,
      selectedData: justSelectedData,
      overrideDataSource: overrideDataSource,
      showCaptionFooter: showCaptionFooter,
      showCaptionHeader: showCaptionHeader,
      isOdata: settingGrid.isOdata,
      idTable: settingGrid.idTable,
      showToolbarTop: settingGrid.showToolbarTop,
      showToolbarBottom: settingGrid.showToolbarBottom,
      toolbarButtonsTopLeft: settingGrid.toolbarButtonsTopLeft,
      toolbarButtonsTopRight: settingGrid.toolbarButtonsTopRight,
      toolbarButtonsBottomLeft: settingGrid.toolbarButtonsBottomLeft,
      toolbarButtonsBottomRight: settingGrid.toolbarButtonsBottomRight,
      isSearchable: settingGrid.searchAndSelect,
      detailOptions: detailOption,
      minSearch: settingGrid.minSearch,
      customNewRowBtn: campoDynamic.settingGrid.customNewRowBtn || 'Nuovo'
    }
    //console.log(instancedDataGrid)
    if (data.dynamic && data.dynamic.settingGrid && data.dynamic.settingGrid.wingap !== undefined) {
      Object.assign(instancedDataGrid, { wingap: data.dynamic.settingGrid.wingap })
    }
    let dataToSend = null
    let campo = data

    let guid = Math.random().toString().replace("0.", "")
    this.componentService.setNewPopUp(guid, component, dataToSend, popupWidth, campo, instancedDataGrid, showCaptionFooter, showCaptionHeader, title);
    this.componentService.outputComponent.subscribe(currentOutput => {

      //console.log('currentOutput-->0',currentOutput)


      if (currentOutput.name == 'onRowExpanded' && currentOutput.guid == guid) {
        let eventToEmit = {
          dataRow: currentOutput.data,
          expandedData: currentOutput.expandedData,
          campo: this.fieldData,
          component: this.input,
          dataGridComponent: this.nicaDataGrid,
          rowIndex: currentOutput.rowIndex,
          guid: currentOutput.guid,

          name: 'onRowExpandedDataGrid'
        }

        this.outPutDataGridEvent.emit(eventToEmit);
      }

      if (currentOutput.name == 'onRowSelectionChange' && currentOutput.guid == guid) {
        if (currentOutput.data[campo.dynamic.valueExpr]) {
          this.dataInput[campo.dataField] = currentOutput.data[campo.dynamic.valueExpr];
        }
        let fatherData = typeof currentOutput.fatherData != 'undefined' ? currentOutput.fatherData : null;

        this.dynamicDataSelection = currentOutput.data;
        if (this.fieldData.customTooltip && this.fieldData.customTooltip.dynamicContent && this.dynamicDataSelection && this.fieldData.customTooltip.typeContent === 'dynamicContent') {
          const dataFieldDisplay = this.fieldData.customTooltip.dynamicContent.match(/\$(\w+)/)[1]
          this.fieldData.customTooltip.content = this.dynamicDataSelection[dataFieldDisplay]
        } else if (this.fieldData.customTooltip && this.fieldData.customTooltip.typeContent === 'inputValue') {
          this.fieldData.customTooltip.content = this.dataSetValue
        }
        let displayExpr = campo.dynamic.displayExpr;
        let valueExpr = campo.dynamic.valueExpr != '' ? campo.dynamic.valueExpr : campo.dynamic.displayExpr;
        let related = campo.dynamic.related;
        let dataField = campo.dataField
        /* 
        if(fatherData){
          this.updateFiedlFromGridSelection(fatherData, dataField, displayExpr, valueExpr, related, component, this.input.nativeElement);

        }
        */
        this.updateFiedlFromGridSelection(currentOutput.data, dataField, displayExpr, valueExpr, related, guid, this.input.nativeElement);

        this.outPutDataGridEvent.emit(currentOutput);


        this.showAutocomplete = false;
      }

      if (currentOutput.name == "onRowMultipleSelectionChange" && currentOutput.guid == guid) {

        if (Array.isArray(currentOutput.dataSelected)) {
          const filteredArray = currentOutput.dataSelected.filter(obj => obj !== undefined);
          let dataSel = filteredArray.map(res => {

            if (campo.dynamic.valueExpr == campo.dynamic.displayExpr) {
              return res[campo.dynamic.valueExpr];
            } else if (campo.dynamic.valueExpr != '' && campo.dynamic.valueExpr != 'object') {
              return res[campo.dynamic.valueExpr];
            } else if (campo.dynamic.valueExpr === 'object') {
              return res;
            } else if (campo.dynamic.displayExpr) {
              return res[campo.dynamic.displayExpr];
            }

          })
          this.dataInput[campo.dataField] = dataSel;

          let related = campo.dynamic.related



          if (related) {

            related.forEach((values, key) => {
              let arrayValue = values.split('|')
              if (arrayValue.length > 0) {
                if (arrayValue[0] == 'object') {
                  this.dataInput[arrayValue[1]] = currentOutput.dataSelected
                } else {
                  let cc = currentOutput.dataSelected.filter(res => res != undefined)
                  let dataSel = cc.map(res => {
                    if (typeof res[arrayValue[0]] != 'undefined') {
                      return res[arrayValue[0]]
                    }
                  });

                  this.dataInput[arrayValue[1]] = dataSel;
                }

              } else {
                let dataSel = currentOutput.dataSelected

                this.dataInput[values] = dataSel;

                //this.dataInput[values] = currentOutput.dataSelected
              }

            })

          }
          this.input.nativeElement.focus()
        }



        this.componentService.destroyOutputComponent()
        this.componentService.destroyCurrentOpenPopUpByGuid(guid);

        this.outPutDataGridEvent.emit(currentOutput);
      }

      if (currentOutput.name == "annullaSelezione" && currentOutput.guid == guid) {


        this.componentService.destroyOutputComponent()
        this.componentService.destroyCurrentOpenPopUpByGuid(guid);

        this.input.nativeElement.focus();

        this.outPutDataGridEvent.emit(currentOutput);
      }
      if (currentOutput.name == "toolbarButtonClick" && currentOutput.guid == guid) {


        let eventToEmit = {
          campo: this.fieldData,
          component: this.input,
          dataGridComponent: currentOutput.masterComponent as NicaDataGridComponent,
          formData: this.dataInput,
          guid: currentOutput.guid,
          buttonEvent: currentOutput.infoEventButtons.name,
          buttonEvents: currentOutput.infoEventButtons,
          name: 'toolbarButtonClick'
        }

        this.outPutDataGridEvent.emit(eventToEmit);

      }

      if (currentOutput.name == "onRowOnlyClick" && currentOutput.guid == guid) {
        this.outPutDataGridEvent.emit(currentOutput);
      }

    })





    //    this.input.nativeElement.focus()
  }

  searchRuntime(value) {
    if (!this.fieldData.dynamic) {
      return
    }

    //ricomincio o no ma setto chekOk a false
    this.checkOk = false

    let fieldDataDynamic = this.fieldData.dynamic;
    this.showAutocomplete = false;
    this.fieldsSearched = []
    this.fieldsToSearched = fieldDataDynamic.service ? this.formTemplateService.getService(fieldDataDynamic.service) : null

    if (!fieldDataDynamic.autocomplete) {
      return
    }

    let api = fieldDataDynamic.dataSource;
    let queryStrigOdata = fieldDataDynamic.queryString;
    let fieldsToSearch = [];
    let groupDataField = ''


    if (typeof fieldDataDynamic.searchOptions != 'undefined') {

      let searchOption: SearchOptions = fieldDataDynamic.searchOptions;
      let myqueryStrigOdata = []

      if (searchOption.service) {
        this.fieldsToSearched = this.formTemplateService.getService(searchOption.service).filter(filtD => filtD.itemType == 'group' || filtD.itemType == 'dettaglio');
      } else if (searchOption.dataFieldToSearch) {
        fieldsToSearch = JSON.parse(JSON.stringify(searchOption.dataFieldToSearch));
        this.fieldsToSearched = fieldsToSearch.filter(filtD => filtD.itemType == 'group' || filtD.itemType == 'dettaglio');


      }


      if (searchOption.dataFielToDisplay) {
        this.dataFielToDisplaySearch = searchOption.dataFielToDisplay
      } else {
        this.dataFielToDisplaySearch = fieldDataDynamic.displayExpr ? fieldDataDynamic.displayExpr : fieldDataDynamic.valueExpr
      }

      if (searchOption.dataFielValueExpr) {
        this.dataFielValueExprSearch = searchOption.dataFielValueExpr
      } else {
        this.dataFielValueExprSearch = fieldDataDynamic.valueExpr != '' ? fieldDataDynamic.valueExpr : fieldDataDynamic.displayExpr
      }


      if (searchOption.related) {
        this.dataFielRelated = searchOption.related
      } else {
        this.dataFielRelated = fieldDataDynamic.related
      }


      fieldsToSearch.filter(res => {
        if (res.itemType == 'dettaglio') {
          groupDataField = res.groupDataField
        }
      })




      // Estrarre e unire i dati da ciascun oggetto
      const dataFieldToSearch = this.fieldsToSearched.reduce((acc, item) => {
        acc.push(...item.data);
        return acc;
      }, []);

      ////console.log(dataFieldToSearch)

      dataFieldToSearch.forEach(fieldData => {
        let type = fieldData.dataType;
        let allowFiltering = typeof fieldData.allowFiltering != 'undefined' ? fieldData.allowFiltering : true;

        if (typeof type != 'undefined' && allowFiltering) {
          if (this.builderOdataSearchString(fieldData.dataField, type, value)) {
            myqueryStrigOdata.push(this.builderOdataSearchString(fieldData.dataField, type, value))
          }
        }
      })

      let queryString = ''

      if (myqueryStrigOdata.length == 0) {
        return
      }
      let joinQueryStringOdata = myqueryStrigOdata.join(' or ')
      queryStrigOdata = joinQueryStringOdata

      if (searchOption.queryString) {
        queryString = searchOption.queryString
        queryStrigOdata = `$filter=(${queryStrigOdata}) and ${queryString}`
      } else {
        queryStrigOdata = `$filter=(${queryStrigOdata})`
      }

      if (searchOption.suffixOdata) {
        let suffix = searchOption.suffixOdata
        queryStrigOdata = `${suffix}(${queryStrigOdata})`

      }

      if (searchOption.api) {
        api = searchOption.api
      }

      if (fieldDataDynamic.queryString) {


        let queryStringNoOdata = this.buildAndTestQueryString(fieldDataDynamic.queryString);

        console.warn(queryStrigOdata, queryStringNoOdata, fieldDataDynamic.queryString);

        //Vado a controllare se nel Path o Query Params(NON ODATA) è presente NULL o UNDEFINED, se si a video faccio notare che deve prima selezionare il campo genitore
        if ((queryStringNoOdata as string).toLowerCase().match(/null/g) || (queryStringNoOdata as string).toLowerCase().match(/undefined/g)) {



          let messaggioValidazione: string = this.fieldData.dynamic.queryString.replace(/[/$]/g, '');


          if (messaggioValidazione.includes('=')) {

            messaggioValidazione = messaggioValidazione.split('=')[1];

          }

          alert(`Selezionare Prima: ${messaggioValidazione}`, 'Attenzione!');


          this.clearData();

          return;
        }





        if (queryStringNoOdata != null) {

          queryStringNoOdata = queryStringNoOdata.includes('?') ? queryStringNoOdata + '&' : queryStringNoOdata + '?';
        }

        queryStrigOdata = queryStringNoOdata + queryStrigOdata



      }

    }


    this.anagraficaService.getElenco(api, '', queryStrigOdata).then(results => {

      if (results['items']) {
        results = results['items']
      }

      this.showPopOver(results, this.fieldsToSearched, groupDataField);

    })

  }

  showPopOver(data, settings, keyFilter) {

    if (!keyFilter) {
      this.fieldsSearched = data;
      this.autocompleteSelection = 'single'
    } else {
      this.autocompleteSelection = 'multiple'
      data.forEach(res => {
        if (res[keyFilter].length > 0) {
          this.fieldsSearched.push(res)
        }
      })

    }






    this.popoverWidth = this.input.nativeElement.offsetWidth;
    let height = this.input.nativeElement.offsetHeight;

    let left = this.input.nativeElement.offsetLeft;
    let top = this.input.nativeElement.offsetTop + height;

    this.showAutocomplete = true;

    /*  if(typeof this.nicaDataGrid != 'undefined'){
 
       this.nicaDataGrid.dataSource =  this.fieldsSearched;
       this.nicaDataGrid.renderGrid();
     } */


    this.targetField = '#' + this.fieldData.dataField
    /*setTimeout(() => {
       this.autocomplete.nativeElement.style.position = 'absolute';
      this.autocomplete.nativeElement.style.top = top + 'px';
      this.autocomplete.nativeElement.style.left = left + 'px';   
    }, 400);
    
*/

  }

  autocompleteFromPopOver(key) {
    this.nicaDataGrid.navigateByKeyboard(key)
  }

  builderOdataSearchString(dataField, tipoCampo, searchText) {

    if (!searchText) {
      return null
    }
    switch (tipoCampo.toLowerCase()) {

      case 'text':

        return `(contains(tolower(${dataField}),'${searchText.toLowerCase()}'))`;
      case 'string':
        return `(contains(tolower(${dataField}),'${searchText.toLowerCase()}'))`;

      case 'number':
        let strToNumber = Number(searchText);
        return `(${dataField} eq ${strToNumber})`;

      case 'date':
        {
          let formattedDate: string = this.formatDate(searchText);

          if (typeof formattedDate !== 'undefined')
            return `(${dataField} eq ${this.formatDate(searchText)})`;

        }
      case 'dateTime':
        {
          let formattedDate: string = this.formatDate(searchText);

          if (typeof formattedDate !== 'undefined')
            return `(${dataField} eq ${this.formatDate(searchText)})`;

        }
      case 'boolean':
        return // `(${dataField} eq ${this.searchText.toLowerCase() === 'true'})`;

      // Aggiungi altri casi per tipi di campo aggiuntivi se necessario

      default:

        return `(contains(tolower(${dataField}),'${searchText.toLowerCase()}'))`;


    }
  }

  /**Fine funzione di dataRourceRemote **/
  buildAndTestQueryString(queryString: string) {
    if (queryString != '') {

      // crea un'espressione regolare per cercare "$filter=(...)"
      let regexFilter = /\$filter=\([^)]*\)*/;
      let regexpQuestionMark = /[?]/g;
      // Esegui la ricerca nella stringa
      let matchFilter = queryString.match(regexFilter);
      let matchQuestionMark = queryString.match(regexpQuestionMark);
      // Verifica se c'è una corrispondenza
      if (matchFilter || matchQuestionMark) {

        let parteSenzaFilter = '';

        if (matchFilter)
          parteSenzaFilter = matchFilter[0].replace(/\$filter=/, '');
        else if (matchQuestionMark)
          parteSenzaFilter = matchFilter[0].replace(/[?]/g, '');
        //rimuovere solo la parte ?$filter= 
        ////console.log("Trovato:", parteSenzaFilter);

        if (parteSenzaFilter.includes('$')) {
          for (let x in this.dataInput) {
            if (queryString.includes(x)) {
              let regex = new RegExp('\\$' + x + '\\b', 'g');

              parteSenzaFilter = parteSenzaFilter.replace(regex, this.dataInput[x]);
              //queryString = queryString.replace('$' + x, this.dataJson[x]);

            }
          }

        }

        ///Tutta la parte con Filter o data va implementatata
        let filterOdataAggiuntivo = parteSenzaFilter;

        queryString = queryString.replace(regexFilter, '');

        //Pezzottissimo
        if (queryString == '?)') {
          queryString = ''
        }
        //............
        queryString = queryString;
      }

      if (queryString.includes('$')) {
        for (let x in this.dataInput) {
          if (queryString.includes(x)) {
            let regex = new RegExp('\\$' + x + '\\b', 'g');
            queryString = queryString.replace(regex, this.dataInput[x]);
            //queryString = queryString.replace('$' + x, this.dataJson[x]);

          }
        }
        queryString = queryString
      }

      return queryString
    }
    else
      return undefined;

  }


  emittendSelectionRow(event) {

    let data = event.data;


    let displayExpr = this.dataFielToDisplaySearch;
    let valueExpr = this.dataFielValueExprSearch
    let related = this.dataFielRelated;
    let dataField = this.fieldData.dataField
    let keyPressed: string = event.keyPressed ? event.keyPressed : undefined;

    this.updateFiedlFromGridSelection(data, dataField, displayExpr, valueExpr, related, null, this.input.nativeElement, keyPressed)
  }


  private formatDate(dateString: string, type: 'EN' | 'it' = 'EN'): string {

    const regExpISO: RegExp = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
    const regExpIT: RegExp = /(\d{1,2})([\/-])(\d{1,2})\2(\d{4})/;


    let isMatchISO = dateString.match(regExpISO);
    let isMatchIT = dateString.match(regExpIT);

    //Se nessuno dei 2 formati è valido
    if (!isMatchISO && !isMatchIT) {
      return undefined;
    }

    if (isMatchIT) {

      if (dateString.includes('-'))
        dateString = `${dateString.split('-')[2]}-${dateString.split('-')[1]}-${dateString.split('-')[0]}`;
      else if (dateString.includes('/'))
        dateString = `${dateString.split('/')[2]}-${dateString.split('/')[1]}-${dateString.split('/')[0]}`;
    }

    const date = new Date(dateString);

    // Formatta la data come necessario
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Mese è 0-based
    const day = date.getDate().toString().padStart(2, '0');
    if (type == 'EN') {
      return `${year}-${month}-${day}`;
    }

    if (type == 'it') {
      return `${day}-${month}-${year} `;
    }
  }

  handleFile(file, dataField) {
    /*  // Debug: verifica i contenuti del formData
     formData.forEach((value, key) => {
       console.log(`${key}: ${value}`);
     }); */

    //let c = this.formGroup.get(dataField)
    //c.setValue(file)
    this.dataInput[dataField] = file;
    //this.dataInput['file'] = file;
    console.log(this.dataInput)
  }
}
